import React, { createContext, useContext, useState, useEffect } from 'react';

const CompanyContext = createContext(null);

const DEFAULT_BRANDING = {
  companyId:     null,
  company_name:  '',
  logo_url:      null,
  favicon_url:   null,
  primary_color: null,
};

export function CompanyProvider({ children }) {
  const [companyDetails, setCompanyDetails] = useState(() => {
    // Restore from localStorage on mount so branding is available immediately
    try {
      const stored = localStorage.getItem('branding');
      return stored ? JSON.parse(stored) : DEFAULT_BRANDING;
    } catch {
      return DEFAULT_BRANDING;
    }
  });

  useEffect(() => {
    const apiBase = process.env.REACT_APP_API_URL || '';

    // Mirrors the PWA pattern: POST with { domain: window.location.host }
    fetch(`${apiBase}/company/branding`, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ domain: window.location.host }),
    })
      .then(res => res.ok ? res.json() : null)
      .then(json => {
        if (!json) return;
        const data = json.data || json;
        if (!data.companyId) return;

        // Persist so the Axios interceptor and auth flow can read it instantly
        localStorage.setItem('companyId', String(data.companyId));
        localStorage.setItem('branding',  JSON.stringify(data));

        setCompanyDetails(data);
        applyBranding(data);
      })
      .catch(() => {
        // Silent fail — use whatever was restored from localStorage
      });
  }, []);

  return (
    <CompanyContext.Provider value={{ companyDetails }}>
      {children}
    </CompanyContext.Provider>
  );
}

export function useCompany() {
  return useContext(CompanyContext);
}

function applyBranding(data) {
  if (data.company_name) {
    // Store the company name for dynamic title updates
    window.__companyName = data.company_name;
    document.title = data.company_name;
  }

  if (data.favicon_url) {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = data.favicon_url;
  }

  if (data.primary_color) {
    document.documentElement.style.setProperty('--brand-primary', data.primary_color);
  }
}

export function setPageTitle(page) {
  const company = window.__companyName || document.title || 'Wiyak';
  const titles = {
    login:          `${company} — Sign In`,
    admin:          `${company} — Admin Panel`,
    test:           `${company} — Assessment`,
    changePassword: `${company} — Set Password`,
  };
  document.title = titles[page] || company;
}
